import { gql } from '@apollo/client'

import { UserFragment } from './user.fragment'
import { FileFragment } from './file.fragment'

export const FormFieldsFragment = gql`
  fragment FormFieldsFragment on FormModelStructure {
    fields {
      ... on ArrayFieldModel {
        id
        type
        label
        required
        cols {
          id
          fields {
            ... on GridTextFieldModel {
              id
              type
              rows {
                id
                label
                columns {
                  id
                  type
                  label
                  required
                  value
                }
              }
            }
            ... on TextFieldModel {
              id
              type
              label
              required
              value
            }
            ... on RadioFieldModel {
              id
              type
              label
              required
              value
              options {
                id
                label
                redirectTo
              }
            }
            ... on CheckboxFieldModel {
              id
              type
              label
              required
              values
              options {
                id
                label
              }
            }
            ... on SelectFieldModel {
              id
              type
              label
              required
              value
              options {
                id
                label
                redirectTo
              }
            }
            ... on SelectEditableFieldModel {
              id
              type
              label
              required
              value
              options {
                id
                label
                redirectTo
              }
            }
            ... on DateFieldModel {
              id
              type
              label
              required
              value
            }
            ... on SignatureFieldModel {
              id
              type
              label
              required
              value
            }
          }
        }
      }
      ... on TitleFieldModel {
        id
        type
        label
      }
      ... on HeaderPictureFieldModel {
        id
        type
        fileId
        file {
          ...FileFragment
        }
      }
      ... on SectionFieldModel {
        id
        type
        label
      }
      ... on TextFieldModel {
        id
        type
        label
        required
        value
      }
      ... on DateFieldModel {
        id
        type
        label
        required
        value
      }
      ... on SignatureFieldModel {
        id
        type
        label
        required
        value
      }
      ... on FileFieldModel {
        id
        type
        label
        required
        fileIds
        files {
          ...FileFragment
        }
      }
      ... on PictureFieldModel {
        id
        type
        label
        required
        fileIds
        files {
          ...FileFragment
        }
      }
      ... on RadioFieldModel {
        id
        type
        label
        required
        value
        options {
          id
          label
          redirectTo
        }
      }
      ... on CheckboxFieldModel {
        id
        type
        label
        required
        values
        options {
          id
          label
        }
      }
      ... on SelectFieldModel {
        id
        type
        label
        required
        value
        options {
          id
          label
          redirectTo
        }
      }
      ... on SelectEditableFieldModel {
        id
        type
        label
        required
        value
        options {
          id
          label
          redirectTo
        }
      }
      ... on FixedTextFieldModel {
        id
        type
        label
        requiredValue
      }
      ... on FixedPictureFieldModel {
        id
        type
        label
        ids
        files {
          ...FileFragment
        }
      }
      ... on FixedFileFieldModel {
        id
        type
        label
        ids
        files {
          ...FileFragment
        }
      }
    }
  }
  ${FileFragment}
`

export const FormModelStructureFragment = gql`
  fragment FormModelStructureFragment on FormModelStructure {
    validationConfig {
      allowAdminEdit
      mode
    }
    ...FormFieldsFragment
  }
  ${FormFieldsFragment}
`

export const FormModelFragment = gql`
  fragment FormModelFragment on FormModel {
    id
    title
    createdDate
    isVisible
    structure {
      ...FormModelStructureFragment
    }
    author {
      ...UserFragment
    }
  }
  ${FormModelStructureFragment}
  ${UserFragment}
`
